module.exports = __webpack_public_path__ + "img/wedding-date.90149cb1.svg";